import { useIntl } from "react-intl"
import { formatNumber } from "helpers/numbers"

type FormatNumberConfig = {
	decimals?: number
	spaceBetween?: boolean
}

type FormatPercentageConfig = {
	decimals?: number
	withPercentageChar?: boolean
	withPositiveSymbol?: boolean
}

export const truncate = (number: number, decimals: number = 0) => {
	const baseTen = Math.pow(10, decimals)
	return Math.floor(number * baseTen) / baseTen
}

const useFormaters = () => {
	const intl = useIntl()

	const formatPercentageWrapper = (
		value: number,
		config: FormatPercentageConfig = {}
	) => {
		const { decimals = 2, withPercentageChar, withPositiveSymbol } = config

		return intl.formatNumber(truncate(value, 4), {
			signDisplay: withPositiveSymbol ? "always" : "auto",
			style: withPercentageChar ? "percent" : "decimal",
			maximumFractionDigits: decimals,
		})
	}

	const formatNumberWrapper = (
		value: number,
		config: FormatNumberConfig = {}
	) => {
		const { decimals = 2, spaceBetween } = config
		return formatNumber(value, intl, decimals, spaceBetween)
	}

	return {
		formatPercentage: formatPercentageWrapper,
		formatNumber: formatNumberWrapper,
	}
}

export default useFormaters
